import type { UserElement, SegmentType } from 'types/userSegment';

export const getTranslationBase = (segmentType: SegmentType, currentUserElement?: UserElement) => {
    if (!currentUserElement) {
        return '';
    }
    return `${segmentType}.${currentUserElement.elementType}_${currentUserElement.elementRank}`;
};
